<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('quote')">
    <vuse-section-definition
      :title="page"
      icon="request_quote"
      v-show="!hideTitle"
    ></vuse-section-definition>

    <v-container fluid>
      <v-row>
        <v-col cols="12" lg="8" md="8" sm="12">
          <v-row>
            <v-col cols="12" lg="4" md="4" sm="4">
              <v-text-field
                v-model="filter.SearchTerm"
                append-icon="mdi-magnify"
                label="Search"
                solo
                :hide-details="true"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="4" md="4" sm="4" v-show="!clientId">
              <client-select
                v-model="filter.clientId"
                append-icon="mdi-magnify"
                label="Client"
                solo
                :hide-details="true"
              />
            </v-col>

            <v-col cols="12" lg="4" md="4" sm="4">
              <QuoteStatusSelect
                clearable
                v-model="filter.status"
                label="Status"
                solo
                :hide-details="true"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="12">
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                color="info"
                @click="newQuote()"
                v-show="hasAccess('quote.add')"
              >
                Add Bid
              </v-btn>
              <v-btn
                color="info"
                @click="$router.push({ path: '/items' })"
                class="ml-3"
                v-show="hasAccess('item.view')"
                >Item List</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <template>
        <v-card class="mt-5">
          <v-skeleton-loader
            v-if="isLoading"
            class="mx-auto"
            type="table"
          ></v-skeleton-loader>
          <v-data-table
            v-else
            :headers="activeHeaders"
            :items="dataItems"
            class="elevation-1"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            :loading="loading"
            @click:row="onEdit"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
            }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn rounded class="content-ma-0 mr-2" v-on="on" x-small>
                      <v-icon small>menu</v-icon> Customize Columns
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item dense :key="i" v-for="(header, i) in headers">
                      <v-list-item-title v-if="header.readonly">
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                          :disabled="true"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </template>

            <template v-slot:item.lastUpdated="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip @click="onEdit(item)" small v-bind="attrs" v-on="on">
                    {{ item.lastUpdated | formatDatetime }}
                  </v-chip>
                </template>
                <span>{{ momentLocal(item.lastUpdated).fromNow() }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.dateCreated="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip @click="onEdit(item)" small v-bind="attrs" v-on="on">
                    {{ item.dateCreated | formatDatetime }}
                  </v-chip>
                </template>
                <span>{{ momentLocal(item.dateCreated).fromNow() }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.client="{ item }">
              <ClientChip
                :clientId="item.clientId"
                :clientName="item.clientName"
              />
            </template>

            <template v-slot:item.status="{ item }">
              <QuoteStatusChip :status="item.status" />
            </template>

            <template v-slot:item.quoteAmount="{ item }">
              {{ (item.quoteAmount + item.quoteTaxAmount) | formatPrice }}
            </template>

            <template v-slot:item.date="{ item }">
              {{ item.date | formatDate }}
            </template>

            <template v-slot:item.dateExpired="{ item }">
              {{ item.dateExpired | formatDate }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon small class="content-ma-0" v-on="on">
                    <v-icon small>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="onClientView(item)">
                    <v-list-item-title>
                      <v-icon small left>remove_red_eye</v-icon>Client View
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-show="isAdmin" @click="onAdminView(item)">
                    <v-list-item-title>
                      <v-icon small left>remove_red_eye</v-icon>Admin View
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="onEmail(item)">
                    <v-list-item-title>
                      <v-icon small left>email</v-icon>Email
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="onApprove(item)"
                    v-show="
                      item.status !== 'approved' && item.status !== 'rejected'
                    "
                  >
                    <v-list-item-title>
                      <v-icon small left>check</v-icon>Approve
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="onReject(item)"
                    v-show="
                      item.status !== 'rejected' && item.status !== 'approved'
                    "
                  >
                    <v-list-item-title>
                      <v-icon small left>close</v-icon>Reject
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="onInvoice(item)"
                    v-show="
                      hasAccess('invoice.add') && item.status === 'approved'
                    "
                  >
                    <v-list-item-title>
                      <v-icon small left>note_add</v-icon>Convert to Invoice
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onEdit(item)"
                    v-show="hasAccess('quote.edit')"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-pencil</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onClone(item)"
                    v-show="hasAccess('quote.add')"
                  >
                    <v-list-item-title>
                      <v-icon small left>filter_none</v-icon>Clone
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onDelete(item)"
                    v-show="
                      account.data.user.id !== item.id &&
                      hasAccess('quote.delete')
                    "
                  >
                    <v-list-item-title>
                      <v-icon small left>delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="onAttachFile(item)"
                    v-show="hasAccess('task.delete')"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-file</v-icon>Attach file
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-container>

    <QuoteFormDialog
      :show="showForm"
      :item="selectedItem"
      :clientId="clientId"
      @onClosed="clearShowForm()"
    />

    <QuoteFormDialog
      :clone="true"
      :show="showClone"
      :item="selectedItem"
      :clientId="clientId"
      @onClosed="clearShowClone()"
    />

    <ViewDialog
      :show="showView"
      :item="selectedItem"
      :clientId="clientId"
      @onClosed="clearShowView()"
    />
    <ViewAdminDialog
      :is-admin="true"
      :show="showAdminView"
      :item="selectedItem"
      :clientId="clientId"
      @onClosed="clearShowAdminView()"
    />

    <close-dialog
      :item="selectedItem"
      :show="showClose"
      @onSucceded="refresh()"
      @onClosed="clearClose()"
    />

    <EmailDialog
      :show="showEmail"
      :item="selectedItem"
      @onClosed="clearEmail()"
    />

    <ChangeStatus
      :item="selectedItem"
      title="Approve Bid {id}"
      :show="showApprove"
      buttonLabel="Approve"
      status="approved"
      buttonClass="success"
      message="Are you sure will approve this bid?"
      @onClosed="clearApprove()"
    />
    <ChangeStatus
      :item="selectedItem"
      title="Reject Bid {id}"
      :show="showReject"
      buttonLabel="Reject"
      buttonClass="error"
      status="rejected"
      message="Are you sure will reject this bid?"
      @onClosed="clearReject()"
    />

    <delete-dialog
      :item="selectedItem"
      :show="showDelete"
      @onSucceded="refresh()"
      @onClosed="clearDelete()"
    />

    <detail
      :item="selectedItem"
      :show="showDetail"
      @onSucceded="refresh()"
      @onClosed="clearDetail()"
    />

    <AttachedFileListDialog
      :show="showAttachFile"
      :item="selectedItem"
      object="quote"
      @onClosed="clearAttachFile()"
      @onSucceded="refresh()"
    />
  </div>
  <NoPermission v-else />
  </div>
</template>

<script>
import validationMixin from "@/mixins/validationMixin";
import DeleteDialog from "./Quotes/_Delete";
import CloseDialog from "./Quotes/_Close";
import ChangeStatus from "./Quotes/_ChangeStatus";
import ViewDialog from "./Quotes/_ViewNew";
import ViewAdminDialog from "./Quotes/_ViewNew";
import Detail from "src/views/Pages/User/_users/_Detail";
import { mapState, mapActions, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import ClientSelect from "components/ClientSelect.vue";
import ClientChip from "components/ClientChip.vue";
import QuoteStatusChip from "components/QuoteStatusChip.vue";
import QuoteFormDialog from "src/views/Pages/Quotes/_Form";
import QuoteStatusSelect from "components/QuoteStatusSelect";
import EmailDialog from "./Quotes/_Email";
import { getStorage, setStorage } from "src/utils/helpers";
import _ from "lodash";
import AttachedFileListDialog from "components/FilesAttachment/AttachedFileListDialog";
import NoPermission from "components/NoPermission";

const SETTING_LIST_KEY = "quotes-columns";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
  },
  {
    text: "Bid #",
    sortable: true,
    value: "id",
    active: true,
  },
  {
    text: "Client",
    sortable: true,
    value: "client",
    active: true,
  },

  {
    text: "Files",
    sortable: true,
    value: "totalFiles",
    active: true,
  },

  {
    text: "Amount",
    sortable: true,
    value: "quoteAmount",
    active: true,
  },
  {
    text: "Status",
    align: "start",
    sortable: true,
    value: "status",
    active: true,
  },
  {
    text: "Due Date",
    sortable: true,
    value: "dateExpired",
    active: true,
  },
  {
    text: "Date",
    sortable: true,
    value: "date",
    active: true,
  },
  {
    text: "Date Created",
    sortable: true,
    value: "dateCreated",
    active: true,
  },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];

export default {
  props: {
    hideTitle: Boolean,
    clientId: Number,
  },
  mixins: [validationMixin, formatterMixin],
  components: {
    ChangeStatus,
    CloseDialog,
    QuoteStatusSelect,
    DeleteDialog,
    Detail,
    ClientSelect,
    QuoteFormDialog,
    ViewDialog,
    ViewAdminDialog,
    QuoteStatusChip,
    EmailDialog,
    ClientChip,
    AttachedFileListDialog,
    NoPermission
  },
  validations: {},
  validationMessages: {},
  data() {
    return {
      namespace: "Quotes",
      page: "Bids",
      loaded: false,

      filter: {
        SearchTerm: null,
        clientId: null,
        status: null,
      },

      tableOptions: {},

      showEmail: false,
      showApprove: false,
      showReject: false,
      showInvoice: false,
      showClone: false,
      showClose: false,
      showDetail: false,
      showEdit: false,
      showDelete: false,
      showForm: false,
      showView: false,
      showAdminView: false,
      showAttachFile: false,
      selectedItem: {},
      clients: [],
      headers: defaultHeaders.map((item) => {
        let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
        let nowHeader = savedHeaders.filter(
          (saved) => saved.value === item.value
        );

        if (nowHeader) {
          nowHeader = nowHeader[0];
        }
        return {
          ...item,
          ...nowHeader,
        };
      }),
    };
  },

  async mounted() {
    this.loaded = true;

    if (this.clientId) {
      this.filter.clientId = this.clientId;
    }

    await this.refresh();

    if (this.isAutoAdd) {
      this.newQuote();
    }
  },

  methods: {
    ...mapActions("quote", ["applyTableFilter", "clearTableFilter"]),

    getClientName(clientId) {
      let found = this.client.data.filter((d) => {
        return d.id == clientId;
      });
      if (found) {
        return found[0];
      }
      return false;
    },

    onAttachFile(item) {
      this.showAttachFile = true;
      this.selectedItem = item;
    },

    async clearAttachFile() {
      this.showAttachFile = false;
      this.selectedItem = {};
      await this.refresh();
    },

    newQuote() {
      if (this.clientId) {
        this.showForm = true;
        this.selectedItem = {};
      } else {
        this.$router.push({ path: "/bids/create" });
      }
    },

    onDelete(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },

    onClone(item) {
      if (this.clientId) {
        this.selectedItem = item;
        this.showClone = true;
      } else {
        this.$router.push(`/bids/${item.id}/clone`);
      }
    },

    onEmail(item) {
      this.selectedItem = item;
      this.showEmail = true;
    },

    onApprove(item) {
      this.selectedItem = item;
      this.showApprove = true;
    },

    onReject(item) {
      this.selectedItem = item;
      this.showReject = true;
    },

    onEdit(item) {
      if (!this.hasAccess("quote.edit")) {
        return false;
      }
      if (this.clientId) {
        this.selectedItem = item;
        this.showForm = true;
      } else {
        this.$router.push(`/bids/${item.id}/edit`);
      }
    },

    onDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
    onInvoice(item) {
      if (this.clientId) {
        this.selectedItem = item;
        this.showInvoice = true;
      } else {
        this.$router.push(`/bids/${item.id}/invoice`);
      }
    },

    onClose(item) {
      this.selectedItem = item;
      this.showClose = true;
    },

    onClientView(item) {
      this.selectedItem = item;
      this.showView = true;
    },

    onAdminView(item) {
      this.selectedItem = item;
      this.showAdminView = true;
    },

    clearInvoice() {
      this.selectedItem = {};
      this.showInvoice = false;
    },
    clearDetail() {
      this.selectedItem = {};
      this.showDetail = false;
    },
    clearEdit() {
      this.selectedItem = {};
      this.showEdit = false;
    },
    clearDelete() {
      this.selectedItem = {};
      this.showDelete = false;
    },

    clearShowForm() {
      this.selectedItem = {};
      this.showForm = false;
    },

    clearShowClone() {
      this.selectedItem = {};
      this.showClone = false;
    },

    clearClose() {
      this.selectedItem = {};
      this.showClose = false;
    },

    clearEmail() {
      this.selectedItem = {};
      this.showEmail = false;
    },

    clearApprove() {
      this.selectedItem = {};
      this.showApprove = false;
    },

    clearReject() {
      this.selectedItem = {};
      this.showReject = false;
    },

    clearShowView() {
      this.selectedItem = {};
      this.showView = false;
    },

    clearShowAdminView() {
      this.selectedItem = {};
      this.showAdminView = false;
    },

    refresh: _.debounce(async function () {
      this.applyTableFilter(this.computedFilter);
    }, 500),
  },

  watch: {
    clientId(n) {
      if (n) {
        this.filter.clientId = n;
      }
    },
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },
    tableOptions: {
      async handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          await this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh();
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
      client: (state) => state.client,
      loading: (state) => state.quote.loadingTable,
      totalItems: (state) => state.quote.metaData.totalEntries,
      isAdmin: (state) => state.account.data.isAdmin,
    }),

    isLoading() {
      return this.loading && this.dataItems.length == 0;
    },

    computedFilter() {
      const { clientId, status, SearchTerm } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };

      params.OrderBy =
        sortBy && sortBy.length > 0 && sortBy[0] ? sortBy[0] : "dateCreated";

      if (sortDesc && sortDesc.length > 0) {
        params.Ascending = !sortDesc[0];
      } else {
        params.Ascending = false;
      }

      if (clientId) {
        params.clientId = clientId;
      }

      if (status) {
        params.status = status;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }
      return params;
    },

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },

    isAutoAdd() {
      return this.optional(this.$route.query, "action", "") === "add-quote";
    },

    actionQuery() {
      return this.$route.query;
    },

    dataItems() {
      let data = this.$store.getters["quote/getAll"];
      return data;
    },

    fakeTotal() {
      let total = 0;
      this.dataItems.map((item) => {
        total += item.quoteAmount;
      });
      return total;
    },

    fakeTotalDue() {
      let total = 0;
      this.dataItems
        .filter((f) => f.status == "Due")
        .map((item) => {
          total += item.quoteAmount;
        });
      return total;
    },

    fakeTotalOverdue() {
      let total = 0;
      this.dataItems
        .filter((f) => f.status == "Overdue")
        .map((item) => {
          total += item.quoteAmount;
        });
      return total;
    },
  },

  beforeDestroy() {
    if (this.clientId) {
      this.clearTableFilter();
    }

    this.$store.dispatch("quote/clearData");
  },
};
</script>